import React, { useCallback } from 'react'
import { ListItem } from '../atoms/builder-2.0/ListItem'
import { BankIcon, CardIconBuilder } from '../../assets/icons'
import { AddBankAccountMethodBottomModal } from './AddBankAccountMethodBottomModal'
import { useInvoiceDetailsContext } from '../../screens/Contractor/TabInvoice/InvoiceDetailsContext'
import { ConnectCardSuccess } from '../organisms/ConnectCardSuccess'
import { paths } from '../../screens/links'
import { useResponsive } from '../../utils/hooks'
import { Col, Row } from '../atoms/Grid'
import { useTranslation } from 'react-i18next'
import { EndIcon } from './EndIcon'
import AddPaymentMethodStore from '../../store/AddPaymentMethodStore'
import { observer } from 'mobx-react-lite'

type AddPaymentMethodItemsProps = {
  desktopView?: boolean
  navigation: any
  canAddBankAccount?: boolean
  onNavigate?: () => void
  goToNextOnboardingPage?: () => void
  sourceInvoice?: string
  alignDirection?: string
  itemStyle: any
  testID?: string
}

function AddCol({ children, alignDirection }) {
  return alignDirection === 'row' ? (
    <Col xs={12} sm={12} md={6} xl={6}>
      {children}
    </Col>
  ) : (
    <>{children}</>
  )
}

export const AddPaymentMethodItems = observer(
  ({
    desktopView = false,
    navigation,
    canAddBankAccount = true,
    onNavigate,
    goToNextOnboardingPage,
    sourceInvoice,
    alignDirection = 'column',
    itemStyle,
    testID,
  }: AddPaymentMethodItemsProps) => {
    const { sm } = useResponsive()
    const { setPayInvoiceModal, cardSuccess } = useInvoiceDetailsContext()
    const { t } = useTranslation('global')
    const { setModal, setChosenMethodTypeFromInvoice } = AddPaymentMethodStore

    const onConnectBank = () => {
      if (onNavigate) {
        onNavigate()
        setChosenMethodTypeFromInvoice('bank')
      } else {
        setModal('addBank', true)
      }
    }
    const onLinkCard = () => {
      setModal('')
      setPayInvoiceModal && setPayInvoiceModal(false) // When add payment method starts from pay invoice modal
      if (onNavigate) {
        onNavigate()
        setChosenMethodTypeFromInvoice('card')
      } else {
        if (sourceInvoice) {
          navigation.navigate(paths.LinkCard, {
            id: sourceInvoice,
          })
        } else {
          if (sm) {
            navigation.navigate(paths.Console.Accounts._self, {
              screen: paths.LinkCard,
            })
          } else {
            navigation.navigate(paths.Console.More._self, {
              screen: paths.Console.More.Wallet,
              params: { screen: paths.LinkCard },
            })
          }
        }
      }
    }

    return (
      <>
        <Row style={{ marginHorizontal: 0 }}>
          {canAddBankAccount && (
            <AddCol alignDirection={alignDirection}>
              <ListItem
                onPress={onConnectBank}
                icon={<BankIcon style={itemStyle?.frontIcon} />}
                title={t('ConnectYourBank')}
                subtitle={t('ConnectionsAreEncrypted')}
                style={itemStyle?.style}
                endIcon={<EndIcon desktopView={desktopView} />}
                otherStyles={itemStyle?.otherStyles}
                testID={testID || 'connectBank'}
              />
            </AddCol>
          )}
          <AddCol alignDirection={alignDirection}>
            <ListItem
              onPress={onLinkCard}
              icon={<CardIconBuilder style={itemStyle?.frontIcon} />}
              title={t('LinkYourCard')}
              subtitle={t('CardDetailsAreTokenized')}
              style={itemStyle?.style}
              endIcon={<EndIcon desktopView={desktopView} />}
              otherStyles={itemStyle?.otherStyles}
              testID={testID || 'linkCard'}
            />
          </AddCol>
        </Row>
        <AddBankAccountMethodBottomModal
          sourceInvoice={sourceInvoice}
          onNavigate={useCallback(() => {
            setModal('')
            goToNextOnboardingPage && goToNextOnboardingPage()
          }, [goToNextOnboardingPage, setModal])}
        />
        <ConnectCardSuccess visible={cardSuccess} />
      </>
    )
  },
)
